import {get} from "lodash";
import AppSettingController from "../../../Main/controller/AppSettingController";
import {ReactComponent as DeleteIcon} from "../../assets/icons/delete.svg";
import MarketSettingLocalStorage from "../../../Main/interface/MarketSettingLocalStorage";
import {useTranslation} from "react-i18next";

export default function DiscountCodsList() {
    const {t, i18n} = useTranslation();
    const lang = i18n.language === 'ar-IQ' ? 'ar-IQ' : 'fa-IR';
    const setting = AppSettingController.getSetting() as MarketSettingLocalStorage;


    return (
        <div className="discount-cods-list-container">
            <div className="desk-list">
                <div className={'desk-list-header'}>
                    <h3>{t("setting.discountList")}</h3>
                </div>
                <div className="desk-list-item">
                    {get(setting, "discount", []).map((item: {
                        id: string,
                        discountCode: string,
                        discountPercentage: string,
                        discountPrice: string,
                        type: string,
                    }) => (
                        <div key={`${item.discountCode}-${item.discountPercentage}`} className={'desk-item'}>
                            <p>{t("setting.discountCode")}: {item.discountCode} - {item.discountPrice ? Number(item.discountPrice).toLocaleString(lang) : "%" + item.discountPercentage}</p>
                            <DeleteIcon onClick={e => AppSettingController.deleteDiscount(item.id)}/>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}